import { projectUpdatedWebhookSchema } from './webhooks/project-updated.webhook.js';
import { pageUpdatedWebhookSchema } from './webhooks/page-updated.webhook.js';
import { documentUpdatedWebhookSchema } from './webhooks/document-updated.webhook.js';
import { documentPagesInfoWebhookSchema, } from './webhooks/document-pages-info-ready.webhook.js';
import { reportReadyWebhookSchema } from './webhooks/report-ready.webhook.js';
import { reportProgressWebhookSchema } from './webhooks/report-progress.webhook.js';
import { projectProgressWebhookSchema } from './webhooks/project-progress.webhook.js';
import { reportFailedWebhookSchema } from './webhooks/report-failed.webhook.js';
import { engineEventsReadyWebhookSchema } from './webhooks/engine-events-ready.webhook.js';
import { thrustConversionEventsReadyWebhookSchema, } from './webhooks/thrust-conversion-events-ready.webhook.js';
import { llpStatusEventsReadyWebhookSchema, } from './webhooks/llp-status-events-ready.webhook.js';
import { adStatusEventsReadyWebhookSchema, } from './webhooks/ad-status-events-ready.webhook.js';
import { ldndStatusEventsReadyWebhookSchema, } from './webhooks/ldnd-status-events-ready.webhook.js';
import { sbStatusEventsReadyWebhookSchema, } from './webhooks/sb-status-events-ready.webhook.js';
import { billOfSaleEventsReadyWebhookSchema, } from './webhooks/bill-of-sale-events-ready.webhook.js';
import { qecListEventsReadyWebhookSchema, } from './webhooks/qec-list-events-ready.webhook.js';
import { pmaDerEventsReadyWebhookSchema, } from './webhooks/pma-der-events-ready.webhook.js';
import { removalTagsReadyWebhookSchema } from './webhooks/removal-tags-ready.webhook.js';
import { nisEventsReadyWebhookSchema } from './webhooks/nis-events-ready.webhook.js';
import { tsnCsnStatementReadyWebhookSchema, } from './webhooks/tsn-csn-statement-ready.webhook.js';
import { llpBtbReadyWebhookSchema } from './webhooks/llp-btb-ready.webhook.js';
import { engineMovementEvidenceReadyWebhookSchema, } from './webhooks/engine-movement-evidence-ready.webhook.js';
import { arcEventsReadyWebhookSchema } from './webhooks/arc-events-ready.webhook.js';
import { buildRecordEventsReadyWebhookSchema, } from './webhooks/build-record-events-ready.webhook.js';
import { engineConfigurationRowsReadyWebhookSchema, } from './webhooks/engine-configuration-rows-ready.webhook.js';
import { moduleExchangeEventsReadyWebhookSchema, } from './webhooks/module-exchange-events-ready.webhook.js';
import { complianceJobCardFactsReadyWebhookSchema, } from './webhooks/compliance-job-card-facts-ready.webhook.js';
import { trackedPartSetReadyWebhookSchema, } from './webhooks/tracked-part-set-ready.webhook.js';
import { pageFailedWebhookSchema } from './webhooks/page-failed.webhook.js';
import { documentFailedWebhookSchema } from './webhooks/document-failed.webhook.js';
import { projectDataReadyWebhookSchema, } from './webhooks/project-data-ready.webhook.js';
import { utilisationSummaryReadyWebhookSchema, } from './webhooks/utilisation-summary-ready.webhook.js';
import { workscopeEventsReadyWebhookSchema, } from './webhooks/workscope-events-ready.webhook.js';
import { documentHeaderReadyWebhookSchema, } from './webhooks/document-header-ready.webhook.js';
import { statusSnapshotReadyWebhookSchema, } from './webhooks/status-snapshot-ready.webhook.js';
export * from './webhooks/project-updated.webhook.js';
export * from './webhooks/page-updated.webhook.js';
export * from './webhooks/document-updated.webhook.js';
export * from './webhooks/document-pages-info-ready.webhook.js';
export * from './webhooks/report-ready.webhook.js';
export * from './webhooks/report-progress.webhook.js';
export * from './webhooks/project-progress.webhook.js';
export * from './webhooks/report-failed.webhook.js';
export * from './webhooks/engine-events-ready.webhook.js';
export * from './webhooks/thrust-conversion-events-ready.webhook.js';
export * from './webhooks/ad-status-events-ready.webhook.js';
export * from './webhooks/ldnd-status-events-ready.webhook.js';
export * from './webhooks/sb-status-events-ready.webhook.js';
export * from './webhooks/bill-of-sale-events-ready.webhook.js';
export * from './webhooks/qec-list-events-ready.webhook.js';
export * from './webhooks/pma-der-events-ready.webhook.js';
export * from './webhooks/nis-events-ready.webhook.js';
export * from './webhooks/tsn-csn-statement-ready.webhook.js';
export * from './webhooks/llp-btb-ready.webhook.js';
export * from './webhooks/engine-movement-evidence-ready.webhook.js';
export * from './webhooks/arc-events-ready.webhook.js';
export * from './webhooks/build-record-events-ready.webhook.js';
export * from './webhooks/engine-configuration-rows-ready.webhook.js';
export * from './webhooks/module-exchange-events-ready.webhook.js';
export * from './webhooks/compliance-job-card-facts-ready.webhook.js';
export * from './webhooks/removal-tags-ready.webhook.js';
export * from './webhooks/tracked-part-set-ready.webhook.js';
export * from './webhooks/page-failed.webhook.js';
export * from './webhooks/document-failed.webhook.js';
export * from './webhooks/project-data-ready.webhook.js';
export * from './webhooks/utilisation-summary-ready.webhook.js';
export * from './webhooks/workscope-events-ready.webhook.js';
export * from './webhooks/document-header-ready.webhook.js';
export * from './webhooks/status-snapshot-ready.webhook.js';
import z from 'zod';
export const webhookPayloadSchema = z.discriminatedUnion('type', [
    projectUpdatedWebhookSchema,
    pageUpdatedWebhookSchema,
    documentUpdatedWebhookSchema,
    documentPagesInfoWebhookSchema,
    reportReadyWebhookSchema,
    reportProgressWebhookSchema,
    projectProgressWebhookSchema,
    reportFailedWebhookSchema,
    engineEventsReadyWebhookSchema,
    thrustConversionEventsReadyWebhookSchema,
    llpStatusEventsReadyWebhookSchema,
    adStatusEventsReadyWebhookSchema,
    ldndStatusEventsReadyWebhookSchema,
    sbStatusEventsReadyWebhookSchema,
    billOfSaleEventsReadyWebhookSchema,
    qecListEventsReadyWebhookSchema,
    pmaDerEventsReadyWebhookSchema,
    nisEventsReadyWebhookSchema,
    tsnCsnStatementReadyWebhookSchema,
    llpBtbReadyWebhookSchema,
    engineMovementEvidenceReadyWebhookSchema,
    arcEventsReadyWebhookSchema,
    buildRecordEventsReadyWebhookSchema,
    engineConfigurationRowsReadyWebhookSchema,
    moduleExchangeEventsReadyWebhookSchema,
    complianceJobCardFactsReadyWebhookSchema,
    trackedPartSetReadyWebhookSchema,
    removalTagsReadyWebhookSchema,
    pageFailedWebhookSchema,
    documentFailedWebhookSchema,
    projectDataReadyWebhookSchema,
    utilisationSummaryReadyWebhookSchema,
    workscopeEventsReadyWebhookSchema,
    documentHeaderReadyWebhookSchema,
    statusSnapshotReadyWebhookSchema,
]);
//# sourceMappingURL=webhooks.js.map